import { LOAD_SERVICES, RESET_SERVICES, SERVICES_LOADED, SYNC_FAILED } from './actionTypes';
import type { IAgronomyAgreementServicesState } from './types';

export const initialState: IAgronomyAgreementServicesState = {
  error: null,
  categories: [],
  loading: false,
  loaded: false,
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_SERVICES:
      return { ...state, error: null, loading: true };
    case SERVICES_LOADED:
      return {
        ...state,
        error: null,
        categories: action.payload.data,
        loading: false,
        loaded: true,
      };
    case RESET_SERVICES:
      return { ...initialState };
    case SYNC_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
